export const defaultTag = {
    title: '종이스탬프의 감성 그대로!',
    description: '적립 및 할인 혜택이 풍성한 제이스탬프 제이스탬프입니다',
    imageUrl: '/images/jstamp.jpg'
};
export const recomTag = {
    title: '지인분이 보낸 추천쿠폰입니다',
    description: '여기를 눌러 보낸 혜택을 확인하세요',
    imageUrl: '/images/recom.jpg',
    url: ''
};
